import store from '@/store';

export const applyMultiCurrencyFeature = (): boolean => {
    const specificIds = ['b41ba057-296b-475d-8661-b0355428edda', 'ee2c94db-3d0a-418c-a694-296b9dccaaf6', 'baae548d-5bf5-49cc-b90a-afcf48e03c3c', '08422f5d-0fc7-4366-b453-6ed8ab86ea49', '98994c8f-e0ab-4754-ab5f-65b6f79c359d', '1babfdaa-0d31-4ced-9f7f-242c68712543','fa4839f1-2223-4524-b9a1-9b926febecc3'];
    const clientEntityID = store.state.selectedScheme.clientEntityID;
    const featureFlagIsOnForMultiCurrency: boolean = process.env.VUE_APP_FEATURE_MULTI_CURRENCY_CHANGES_IS_LIVE === 'true';
    return featureFlagIsOnForMultiCurrency || specificIds.includes(clientEntityID);
};